module.exports = __webpack_public_path__ + "static/calendar.f7140445.svg";